import React, {useState, useEffect} from "react"
import { useStaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Videos from "../components/gallery/videos"

const GalleryPage = () => {
  const [showDrop, setShowDrop] = useState(false)

  const handleScroll = (e) => {
    if ( e.currentTarget && e.currentTarget.scrollY){
      const sd = (e.currentTarget.scrollY === 0) ? false:true;
      setShowDrop(sd)
    } else {
      setShowDrop(false);
    }
  }
  useEffect(()=>{
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
    }
  
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('scroll', handleScroll)
      }
    }
  })

  const data = useStaticQuery(graphql`
    query {
      allYoutubeJson {
        edges {
          node {
            publishedAt
            thumbnail
            title
            id
            description
          }
        }
      }
    }
  `)
  const placeholders = data.allYoutubeJson.edges.map(n => {
    return n.node;
  })
  return (
    <Layout page="gallery_page" showHeaderBg={true} navColor="blue" showDrop={showDrop}>
      <SEO title="The Eye Love Project - Gallery" />
      <Videos videos={placeholders} />
    </Layout>
  )
}

export default GalleryPage
